import React, { useState } from 'react';
import { useWeb3 } from '../context/Web3Context';
import { shortenAddress } from '../utils/helpers';
import '../styles/wallet.css';

export default function WalletButton({ onNotify }) {
  const { account, connectWallet, disconnectWallet, loading } = useWeb3();
  const [showMenu, setShowMenu] = useState(false);

  async function handleConnect() {
    const result = await connectWallet();
    if (!result.success && onNotify) {
      onNotify(result.error, 'error');
    }
  }

  function handleDisconnect() {
    disconnectWallet();
    setShowMenu(false);
    if (onNotify) onNotify('Wallet disconnected', 'info');
  }

  if (loading) {
    return <button className="wallet-btn connecting" disabled>Connecting...</button>;
  }

  if (!account) {
    return <button className="wallet-btn" onClick={handleConnect}>Connect</button>;
  }

  return (
    <div className="wallet-connected">
      <button className="wallet-btn active" onClick={() => setShowMenu(!showMenu)}>
        {shortenAddress(account)}
      </button>
      {showMenu && (
        <div className="wallet-menu">
          <button onClick={handleDisconnect}>Disconnect</button>
        </div>
      )}
    </div>
  );
}
